var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-input', {
    ref: "field",
    staticClass: "company-phone-input",
    attrs: {
      "value": _vm.number,
      "rules": _vm.rules,
      "hide-details": _vm.hideDetails
    }
  }, [_c('VuePhoneNumberInput', {
    staticClass: "company-phone-input__field",
    attrs: {
      "default-country-code": _vm.countryCode,
      "error": _vm.showError,
      "clearable": _vm.clearable,
      "translations": _vm.translations
    },
    on: {
      "update": _vm.onUpdate
    },
    model: {
      value: _vm.number,
      callback: function ($$v) {
        _vm.number = $$v;
      },
      expression: "number"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }